// extracted by mini-css-extract-plugin
export default {"textNoDecoration":"global_textNoDecoration__nZYWV"};